import { type Static, Type } from '@sinclair/typebox';
import { MongooseRefSchema } from './common.dto.js';
import { PodcastEpisodeDTOSchema } from './podcast-episode.dto.js';
import { UserDTOSchema } from './user.dto.js';

export const CommentDTOSchema = Type.Transform(
  Type.Recursive(Self =>
    Type.Object({
      _id: Type.String(),
      author: Type.Optional(Type.Pick(UserDTOSchema, ['_id', 'pseudo'])),
      content: Type.String(),
      createdAt: Type.Optional(Type.Any({ type: 'string', format: 'date-time' })),
      deleted: Type.Optional(Type.Boolean()),
      hasReplies: Type.Boolean(),
      item: MongooseRefSchema(PodcastEpisodeDTOSchema),
      likes: Type.Array(Type.Union([Type.String(), UserDTOSchema])),
      parentComment: Type.Optional(MongooseRefSchema(Self)),
      repliesCount: Type.Optional(Type.Number()),
      updatedAt: Type.Optional(Type.Any({ type: 'string', format: 'date-time' })),
    }),
  ),
)
  .Decode(v => v)
  .Encode(v => {
    if (v.deleted) {
      v.author = undefined;
      v.content = '';
    }
    return v;
  });
export type CommentDTO = Static<typeof CommentDTOSchema>;
